import { findIndex, concat, uniqWith, isEqual, mapKeys, filter } from "lodash";

export default (state = {}, action = {}) => {
  switch (action.type) {
    case "ADD_MESSAGE":
      return { ...state, message: action.message };
    case "RESET_WORK_ORDER":
      return {
        ...state,
        singleAsset: {},
        singleCustomer: {},
        part: [],
        showSingleAsset: false,
        showSingleCustomer: false,
        shipInfo: {},
        showNewSiteBox: false
      };
    case "DELETE_MESSAGE":
      return { ...state, message: "" };
    case "CUSTOMER_LIST":
      return { ...state, ...action.payload };
    case "GET_SINGLE_CUSTOMER": {
      const index = findIndex(state.customers, { id: action.id });
      return {
        ...state,
        contractSite: state.customers[index],
        customerSite: state.customers[index].address,
        singleCustomer: state.customers[index],
        showSingleCustomer: true
      };
    }
    case "SET_SINGLE_CUSTOMER":
      return {
        ...state,
        customerSite: action.customer.address,
        singleCustomer: action.customer,
        showSingleCustomer: true
      };
    case "GET_SINGLE_ASSET":
      return { ...state, singleAsset: action.asset, showSingleAsset: true };
    case "CHANGE_SINGLE_CUSTOMER":
      return { ...state, singleCustomer: {}, ...action.payload };
    case "ADD_NEW_SITE":
      return { ...state, shipInfo: action.payload, showNewSiteBox: true };
    case "ADD_PART": {
      const { part } = state;
      const concatState = concat(part, action.payload);
      return { ...state, part: uniqWith(concatState, isEqual) };
    }
    default:
      return state;
  }
};
